import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DxTopbar from './DxTopbar.vue';
import DxNavbar from './DxNavbar.vue';
import DxNavbarAside from './DxNavbarAside.vue';
import DxNavbarAsideItem from './DxNavbarAsideItem.vue';
import DxLoginModal from './DxLoginModal.vue';
import DxModal from './DxModal.vue';
import DxText from './DxText.vue';
import DxHeading from './DxHeading.vue';
import DxButton from './DxButton.vue';
import DxInput from './DxInput.vue';
import DxLink from './DxLink.vue';
import DxForm from './DxForm.vue';
import DxTabs from './DxTabs.vue';
import DxAlert from './DxAlert.vue';
import DxList from './DxList.vue';
import DxListItem from './DxListItem.vue';
import DxAvatar from './DxAvatar.vue';
import DxContent from './DxContent.vue';
import DxTable from './DxTable.vue';
import DxTbody from './DxTbody.vue';
import DxTd from './DxTd.vue';
import DxTh from './DxTh.vue';
import DxThead from './DxThead.vue';
import DxTr from './DxTr.vue';
import DxAsync from './DxAsync.vue';
import DxSelect from './DxSelect.vue';
import DxSwitch from './DxSwitch.vue';
import DxTextarea from './DxTextarea.vue';
import DxCollapse from './DxCollapse.vue';
import DxGrid from './DxGrid.vue';
import DxStepper from './DxStepper.vue';
import DxPagination from './DxPagination.vue';
import DxBadge from './DxBadge.vue';
import DxCheckbox from './DxCheckbox.vue';
import DxLoader from './DxLoader.vue';

const setup = (app) => {
  app.component('dx-icon', FontAwesomeIcon);
  app.component('dx-topbar', DxTopbar);
  app.component('dx-navbar', DxNavbar);
  app.component('dx-navbar-aside', DxNavbarAside);
  app.component('dx-navbar-aside-item', DxNavbarAsideItem);
  app.component('dx-login-modal', DxLoginModal);
  app.component('dx-modal', DxModal);
  app.component('dx-text', DxText);
  app.component('dx-heading', DxHeading);
  app.component('dx-button', DxButton);
  app.component('dx-input', DxInput);
  app.component('dx-link', DxLink);
  app.component('dx-form', DxForm);
  app.component('dx-tabs', DxTabs);
  app.component('dx-alert', DxAlert);
  app.component('dx-list', DxList);
  app.component('dx-list-item', DxListItem);
  app.component('dx-avatar', DxAvatar);
  app.component('dx-content', DxContent);
  app.component('dx-table', DxTable);
  app.component('dx-tbody', DxTbody);
  app.component('dx-td', DxTd);
  app.component('dx-th', DxTh);
  app.component('dx-thead', DxThead);
  app.component('dx-tr', DxTr);
  app.component('dx-async', DxAsync);
  app.component('dx-select', DxSelect);
  app.component('dx-switch', DxSwitch);
  app.component('dx-textarea', DxTextarea);
  app.component('dx-collapse', DxCollapse);
  app.component('dx-grid', DxGrid);
  app.component('dx-stepper', DxStepper);
  app.component('dx-pagination', DxPagination);
  app.component('dx-badge', DxBadge);
  app.component('dx-checkbox', DxCheckbox);
  app.component('dx-loader', DxLoader);
};

export default {
  setup,
};
